// src/components/event/Poll.js
// Updated: 10/17/2025 01:31 PM

import React, { useState } from 'react';
import { db } from '../../firebase/config';
import { doc, updateDoc, arrayUnion } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const Poll = ({ poll, familyId, eventId }) => {
  const { userData } = useAuth();
  const [voted, setVoted] = useState(poll.voters.includes(userData.uid));

  const totalVotes = poll.options.reduce((sum, opt) => sum + opt.votes, 0);

  const handleVote = async (optionIndex) => {
    if (voted) {
      toast.error("You have already voted in this poll.");
      return;
    }

    const newOptions = [...poll.options];
    newOptions[optionIndex].votes += 1;

    const pollDocRef = doc(db, `families/${familyId}/events/${eventId}/polls/${poll.id}`);
    try {
      await updateDoc(pollDocRef, {
        options: newOptions,
        voters: arrayUnion(userData.uid),
      });
      setVoted(true);
      toast.success("Your vote has been counted!");
    } catch (error) {
      console.error("Error voting:", error);
      toast.error("Failed to cast vote.");
    }
  };

  return (
    <div className="p-4 border rounded-lg">
      <h3 className="font-semibold text-lg text-gray-800">{poll.question}</h3>
      <div className="mt-4 space-y-3">
        {poll.options.map((option, index) => {
          const percentage = totalVotes > 0 ? (option.votes / totalVotes) * 100 : 0;
          return (
            <div key={index}>
              {!voted ? (
                <button onClick={() => handleVote(index)} className="w-full text-left p-3 border rounded-md hover:bg-gray-100 transition-colors">
                  {option.text}
                </button>
              ) : (
                <div>
                  <div className="flex justify-between items-center text-sm mb-1">
                    <span className="font-medium">{option.text}</span>
                    <span className="text-gray-500">{option.votes} vote(s) ({percentage.toFixed(0)}%)</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-4">
                    <div className="bg-primary h-4 rounded-full" style={{ width: `${percentage}%` }}></div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      <p className="text-xs text-gray-400 mt-4 text-right">Total Votes: {totalVotes}</p>
    </div>
  );
};

export default Poll;